import React from "react";

import ReactPaginate from "react-paginate";

import "./pagination.scss";

const handlePageClick = (props, object) => {
  const { onHandleChangeStore } = props;

  onHandleChangeStore(object.selected + 1);
};

const Pagination = (props) => {
  const { totalCount, count, page, pageRangeDisplayed = 2 } = props;
  const allPages = Math.ceil(totalCount / count);

  return count < 1 ? null : (
    <div className="pagination">
      <ReactPaginate
        previousLabel={""}
        nextLabel={""}
        breakLabel={"..."}
        breakClassName={"break-me"}
        forcePage={page - 1}
        pageCount={allPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={pageRangeDisplayed}
        onPageChange={handlePageClick.bind(this, props)}
        activeClassName={"active"}
        activeLinkClass={"active-link"}
        nextLinkClassName={"icon-arr"}
        previousLinkClassName={"icon-arr1"}
        hideDisabled={true}
        hideFirstLastPages={true}
      />
    </div>
  );
};

export default React.memo(Pagination);
